import React from 'react';
import AppLayout from "../../../layouts/AppLayout";
import OldNavBar from "../../../components/navbar/OldNavBar";
import {Route, Switch, useRouteMatch} from "react-router";
import EmailTemplatesScene from "./EmailTemplatesScene";
import SubLicensesScene from "./LicensesScene";

export default function SettingsScene() {
  const {path} = useRouteMatch();

  return (
    <>
      <AppLayout className={'bg-white'}>
        <div className="flex flex-row pb-20">
          <OldNavBar/>
          <div className="pt-8 w-full pl-5 pr-40 mr-2">
            <Switch>
              <Route path={`${path}/email-templates`} component={EmailTemplatesScene}/>
              <Route path={`${path}/sub-licenses`} component={SubLicensesScene}/>
            </Switch>
          </div>
        </div>
      </AppLayout>
    </>
  );
}
